__turbopack_context__.v({
  "Label": "theme-dropdown-option-module-scss-module__MrlELq__Label",
  "Option": "theme-dropdown-option-module-scss-module__MrlELq__Option",
});
